<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!item"
            :item="item"
            @success="resetItems"
            @cancel="item = false"
            v-show="hasPermissionDelete"
            @delete-item="deleteType"
        ></view-item>

        <list-items
            v-else
            title="Order Types"
            :items="items"
            v-show="hasPermissionView"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="item = {}"
                    v-show="hasPermissionCreate"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'orderTypes',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            item: null,
        }
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        items() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('orderType/fetchAll')
        },

        showItem(id) {
            this.item = this.items.find(x => x.id === id)
        },

        resetItems(status) {
            this.doToast('Success', `Item ${status}!`, 'success')
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
